import { config } from 'config';
import i18n from 'i18nextInstance';

const { diagnosisShowReasons } = config;

export const TABLE = [{
    key: 'last_name',
    label: i18n.t('Apellido')
}, {
    key: 'first_name',
    label: i18n.t('Nombre')
}, {
    key: 'total_licenses',
    label: i18n.t('Licencias')
}, {
    key: 'total_license_days',
    label: i18n.t('Días totales')
}].filter(({ display = true }) => !!display);

export const downloadHeaders = [{
    key: 'patient_identification',
    label: i18n.t('DNIPaciente')
},
{
    key: 'patient_last_name',
    label: i18n.t('Apellido')
},
{
    key: 'patient_first_name',
    label: i18n.t('Nombre')
},
{
    key: 'patient_file_number',
    label: i18n.t('Legajo')
},
{
    key: 'patient_admission_date',
    label: i18n.t('Fecha de ingreso')
},
{
    key: 'patient_workplace',
    label: i18n.t('Lugar de trabajo')
},
{
    key: 'patient_hr_head',
    label: i18n.t('Jefe de RRHH')
},
{
    key: 'patient_position',
    label: i18n.t('Cargo')
},
{
    key: 'patient_family_burden',
    label: i18n.t('Carga de familia')
},
{
    key: 'patient_gender',
    label: i18n.t('Sexo')
},
{
    key: 'patient_age',
    label: i18n.t('Edad')
},
{
    key: 'doctor_identification',
    label: i18n.t('DNI profesional')
},
{
    key: 'doctor_last_name',
    label: i18n.t('Apellido')
},
{
    key: 'doctor_first_name',
    label: i18n.t('Nombre')
},
{
    key: 'diagnostic_date_date',
    label: i18n.t('Fecha')
},
{
    key: 'diagnostic_date_time',
    label: i18n.t('Hora')
},
{
    key: 'license_attention_type',
    label: i18n.t('Atención')
},
{
    key: 'license_from_date',
    label: i18n.t('Desde')
},
{
    key: 'license_to_date',
    label: i18n.t('Hasta')
},
{
    key: 'license_days',
    label: i18n.t('Días')
},
{
    key: 'license_external_request',
    label: i18n.t('Solicitud externa')
},
{
    key: 'license_requested_from_date',
    label: i18n.t('Solicitado desde')
},
{
    key: 'license_requested_to_date',
    label: i18n.t('Solicitado hasta')
},
{
    key: 'license_requested_days',
    label: i18n.t('Días solicitados')
},
{
    key: 'license_reason',
    label: i18n.t('Razón')
},
{
    key: 'license_next_step',
    label: i18n.t('Siguiente paso')
},
{
    key: 'license_next_step_date',
    label: i18n.t('Fecha de siguiente paso')
},
{
    key: 'note',
    label: i18n.t('Observaciones')
},
{
    key: 'recommendation',
    label: i18n.t('Recomendaciones')
},
{
    key: 'diagnoses',
    label: i18n.t('Diagnóstico')
},
{
    key: 'diagnosis_code',
    label: i18n.t('Código')
},
{
    key: 'diagnostic_status',
    label: i18n.t('Tipo de diagnóstico')
},
{
    hidden: !diagnosisShowReasons,
    key: 'consultation_reasons',
    label: i18n.t('Motivo de consulta')
}];
